/* tslint:disable */
/* eslint-disable */
/**
 * SLOeats API
 * Interal API to the SLOeats platform.
 *
 * The version of the OpenAPI document: 
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface ProStatus
 */
export interface ProStatus {
    /**
     * 
     * @type {boolean}
     * @memberof ProStatus
     */
    readonly is_pro: boolean;
}

/**
 * Check if a given object implements the ProStatus interface.
 */
export function instanceOfProStatus(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "is_pro" in value;

    return isInstance;
}

export function ProStatusFromJSON(json: any): ProStatus {
    return ProStatusFromJSONTyped(json, false);
}

export function ProStatusFromJSONTyped(json: any, ignoreDiscriminator: boolean): ProStatus {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'is_pro': json['is_pro'],
    };
}

export function ProStatusToJSON(value?: ProStatus | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
    };
}

